import addItem from "./additem";
import { combineReducers } from "redux"

const rootReducers = combineReducers({
   addItem 
})
export default rootReducers